import breadcrumbs from './modules/breadcrumbs'

export default {
  breadcrumbs,
}
